"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.SelectPickupPointDialog = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _components = require("./components");
var _useDrawerHeight = require("./hooks/useDrawerHeight");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const transitionProps = {
    timeout: 0
};
const SelectPickupPointDialog = (param)=>{
    let { open } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const isMobile = (0, _mui.useMediaQuery)((theme)=>theme.breakpoints.down('md'));
    const { togglePickupPointsDialog } = (0, _contexts.useMap)();
    const drawerRef = (0, _react.useRef)(null);
    const { height, focusOnList, focusOnMap, onTouchStart } = (0, _useDrawerHeight.useDrawerHeight)(drawerRef);
    if (isMobile) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                visibility: open ? 'visible' : 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Map, {
                    onMapClick: focusOnMap
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Drawer, {
                    ref: drawerRef,
                    style: {
                        height
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
                        ref: drawerRef,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.DragHandle, {
                                onClick: focusOnList,
                                onTouchStart: onTouchStart
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.LeftPanel, {
                                onPickupPointsListClick: focusOnList
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Dialog, {
        hideCloseButton: true,
        open: open,
        size: "small",
        transitionProps: transitionProps,
        "data-testid": getTestId(_models.TestId.SelectPickupPointDialog),
        onClose: togglePickupPointsDialog,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.LeftPanel, {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Map, {})
            ]
        })
    });
};
exports.SelectPickupPointDialog = SelectPickupPointDialog;
var _default = exports.default = SelectPickupPointDialog;
